export class RouteOptions{
    public static avoidTolls:boolean = false;
    public static historyCheck:boolean = true;
}